export default [
	{
		key: 'product',
		title: 'Produk Group',
		scopedSlots: {customRender: 'product'},
	}, {
		dataIndex: 'source_account',
		key: 'source_account',
		title: 'Source Account',
		scopedSlots: {customRender: 'source_account'},
	}, {
		dataIndex: 'biller_fee_account',
		key: 'biller_fee_account',
		title: 'Biller Fee Account',
		scopedSlots: {customRender: 'biller_fee_account'}
	}, {
		dataIndex: 'biller_amount_account',
		key: 'biller_amount_account',
		title: 'Biller Amount Account',
		scopedSlots: {customRender: 'biller_amount_account'}
	}, {
		dataIndex: 'profit_fee_account',
		key: 'profit_fee_account',
		title: 'Profit Fee Account',
		scopedSlots: {customRender: 'profit_fee_account'}
	}, {
		dataIndex: 'transaction_account',
		key: 'transaction_account',
		title: 'Transaction Account',
		scopedSlots: {customRender: 'transaction_account'}
	}, {
		key: 'sponsor_fee_threshold',
		title: 'Treshold Sponsor Fee',
		scopedSlots: {customRender: 'sponsor_fee_threshold'}
	}, {
		key: 'action',
		title: '',
		align: 'right',
		width: 150,
		scopedSlots: {customRender: 'action'}
	}
]
